export default "__VITE_ASSET__B7_kuNsK__"